import React, { useContext, useMemo } from 'react';
import { CurrentPageContext } from 'app/home/general-components/HistoryStackContext';
import { LocalizationContext } from 'app/localization/Context';

import { MainDetail } from './main/Main';
import { getBindInfo } from 'app/model/BindData';

import './CreateBind.scss'

function BindDetail({ gateway }) {
    const l = useContext(LocalizationContext);
    const p = useContext(CurrentPageContext);

    const dismissHandler = p.dismiss;
    const bind = useMemo(() => {
        return gateway.binds.find(({ id }) => id === p.state);
    }, [p, gateway.binds]);

    const isBackgroundRed = useMemo(() => {
        if (bind !== undefined) {
            let _noDay = false;
            if (bind.day_of_week !== undefined) {
                _noDay = bind.day_of_week.filter(v => v).length === 0;
            }
            if (_noDay)
                return true;

            const [conditionInfos, actionInfos] = getBindInfo(bind, gateway.devices, gateway.scenarios, l);
            if (conditionInfos.length === 0)
                return true;
            if (actionInfos.length === 0)
                return true;
            if (bind.participates_in_cycle)
                return true;
        }
        return false;
    }, [bind, gateway.devices, gateway.scenarios, l]);

    return (
        <div className="create-bind-page">
            <div className="bg-blank" />
            <div className="bg-secondary-color" />

            <div className="bg-blank" style={{ zIndex: -9, opacity: isBackgroundRed ? 1 : 0, transition: "opacity 0.5s linear" }} />
            <div className="bg-alarm-color" style={{ zIndex: -8, opacity: isBackgroundRed ? 1 : 0, transition: "opacity 0.5s linear" }} />

            <MainDetail
                bind={bind} devices={gateway.devices} scenarios={gateway.scenarios}
                currentUser={gateway.currentUser}
                negotiatedProtocol={gateway.negotiatedProtocol}
                dismissHandler={dismissHandler} />

        </div>
    )

}

export default BindDetail;